import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CustomerService } from '../proxy/controlling/controllers/customer.service';

FieldBuilder.setNamespace('Controlling');

export const CUSTOMERCOMPANYCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('companyCode', 'Entity.CustomerCompanyCode.CompanyCode')
    .required()
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder
    .text('reconciliationAccount', 'Entity.CustomerCompanyCode.ReconciliationAccount')
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('termsOfPayment', 'Entity.CustomerCompanyCode.TermsOfPayment')
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder
    .foreignKey('customerId', 'Entity.Customer', CustomerService)
    .required()
    .displayFromNested('customer.name')
    .sortBy('customer.name')
    .build(),
];

export const CUSTOMERCOMPANYCODE_CONFIG = {
  entityName: 'CustomerCompanyCode',
  localizationKey: 'Controlling::Entity.CustomerCompanyCode',
  fields: CUSTOMERCOMPANYCODE_FIELDS,
  permission: 'ControllingContract.CustomerCompanyCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Contracts + MENU_NAME_SUFFIX,
};
